import { ZoneHelpers } from '@diagram/helpers/ZoneHelpers';

import {
    AcGroundingConfigurationEnum,
    Bus,
    DiagramComponentInstance,
    ZoneValidationError,
    ZoneValidationErrorType,
    ZoneValidator,
} from 'models';

const busEarthingConfiguration = (componentInstance: DiagramComponentInstance): string | null =>
    componentInstance.componentType === 'bus' && !componentInstance.disabled
        ? ((componentInstance.specifications.electrical as Bus['electrical']).earthing?.configuration ?? null)
        : null;

const galvanicZoneValidator: ZoneValidator['validator'] = ({ zones }) => {
    const errors: ZoneValidationError[] = [];

    zones.forEach((zone) => {
        const earthedBuses = zone.componentInstances.filter((componentInstance) => {
            const configuration = busEarthingConfiguration(componentInstance);

            return configuration !== null && configuration !== AcGroundingConfigurationEnum.UNEARTHED;
        });

        // An explicitly unearthed (floating) bus is a deliberate choice rather than a missing
        // grounding, but it does not act as a ground reference either.
        const floatingBuses = zone.componentInstances.filter(
            (componentInstance) =>
                busEarthingConfiguration(componentInstance) === AcGroundingConfigurationEnum.UNEARTHED,
        );

        if (earthedBuses.length === 0 && floatingBuses.length === 0) {
            ZoneHelpers.warning(errors, ZoneValidationErrorType.GROUNDING_MISSING, zone);
        }

        if (earthedBuses.length > 1) {
            ZoneHelpers.error(errors, ZoneValidationErrorType.GROUNDING_MULTIPLE, zone, earthedBuses);
        }
    });

    return errors;
};

export { galvanicZoneValidator };
